import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface WatchlistFooterProps {
  onClearAll: () => void;
  disabled?: boolean;
}

/**
 * Watchlist 下拉菜单底部组件
 * 显示 "Clear All" 按钮
 */
export function WatchlistFooter({ onClearAll, disabled }: WatchlistFooterProps) {
  const { t } = useTranslation('chrome');
  return (
    <div className="px-4 py-3 border-t">
      <Button
        variant="outline"
        size="sm"
        className="w-full"
        onClick={onClearAll}
        disabled={disabled}
      >
        {t('watchlist.clearAll')}
      </Button>
    </div>
  );
}
